import { render, staticRenderFns } from "./EditPanel.vue?vue&type=template&id=56dff15c&scoped=true"
import script from "./EditPanel.vue?vue&type=script&lang=js"
export * from "./EditPanel.vue?vue&type=script&lang=js"
import style0 from "./EditPanel.vue?vue&type=style&index=0&id=56dff15c&prod&scoped=true&lang=less"
import style1 from "./EditPanel.vue?vue&type=style&index=1&id=56dff15c&prod&lang=less"
import style2 from "./EditPanel.vue?vue&type=style&index=2&id=56dff15c&prod&scoped=true&lang=less"
import style3 from "./EditPanel.vue?vue&type=style&index=3&id=56dff15c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dff15c",
  null
  
)

export default component.exports